export const sanitizeMetadataFieldName = (fieldName: string) => {
	if (fieldName.includes('metadata-')) {
		return fieldName.replace('metadata-', '');
	}
	return fieldName;
};
